"use strict";
// @generated by protoc-gen-es v1.10.0 with parameter "target=ts,import_extension=none"
// @generated from file spwn/stream/v1/admin_service.proto (package spwn.stream.v1, syntax proto3)
/* eslint-disable */
// @ts-nocheck
Object.defineProperty(exports, "__esModule", { value: true });
exports.AdminStreamServiceGetPremierStreamingScheduleResponse_Schedule = exports.AdminStreamServiceGetPremierStreamingScheduleResponse = exports.AdminStreamServiceGetPremierStreamingScheduleRequest = exports.AdminStreamServiceGetMediaLiveChannelsResponse = exports.AdminStreamServiceGetMediaLiveChannelsRequest = exports.AdminStreamServiceGetMediaPackageEndpointsResponse = exports.AdminStreamServiceGetMediaPackageEndpointsRequest = exports.AdminStreamServiceDeleteRestrictedStreamingSettingResponse = exports.AdminStreamServiceDeleteRestrictedStreamingSettingRequest = exports.AdminStreamServiceUpdateRestrictedStreamingSettingResponse = exports.AdminStreamServiceUpdateRestrictedStreamingSettingRequest = exports.AdminStreamServiceCreateRestrictedStreamingPageUrlResponse = exports.AdminStreamServiceCreateRestrictedStreamingPageUrlRequest = exports.AdminStreamServiceGetRestrictedStreamingSettingResponse = exports.AdminStreamServiceGetRestrictedStreamingSettingRequest = exports.AdminStreamServiceGetHoldingStreamInfoResponse = exports.AdminStreamServiceGetHoldingStreamInfoRequest = void 0;
const protobuf_1 = require("@bufbuild/protobuf");
const admin_common_pb_1 = require("./admin_common_pb");
/**
 * @generated from message spwn.stream.v1.AdminStreamServiceGetHoldingStreamInfoRequest
 */
class AdminStreamServiceGetHoldingStreamInfoRequest extends protobuf_1.Message {
    constructor(data) {
        super();
        /**
         * @generated from field: string event_id = 1;
         */
        this.eventId = "";
        protobuf_1.proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new AdminStreamServiceGetHoldingStreamInfoRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new AdminStreamServiceGetHoldingStreamInfoRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new AdminStreamServiceGetHoldingStreamInfoRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return protobuf_1.proto3.util.equals(AdminStreamServiceGetHoldingStreamInfoRequest, a, b);
    }
}
exports.AdminStreamServiceGetHoldingStreamInfoRequest = AdminStreamServiceGetHoldingStreamInfoRequest;
AdminStreamServiceGetHoldingStreamInfoRequest.runtime = protobuf_1.proto3;
AdminStreamServiceGetHoldingStreamInfoRequest.typeName = "spwn.stream.v1.AdminStreamServiceGetHoldingStreamInfoRequest";
AdminStreamServiceGetHoldingStreamInfoRequest.fields = protobuf_1.proto3.util.newFieldList(() => [
    { no: 1, name: "event_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
]);
/**
 * @generated from message spwn.stream.v1.AdminStreamServiceGetHoldingStreamInfoResponse
 */
class AdminStreamServiceGetHoldingStreamInfoResponse extends protobuf_1.Message {
    constructor(data) {
        super();
        /**
         * @generated from field: repeated spwn.stream.v1.HoldingChannel channels = 1;
         */
        this.channels = [];
        protobuf_1.proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new AdminStreamServiceGetHoldingStreamInfoResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new AdminStreamServiceGetHoldingStreamInfoResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new AdminStreamServiceGetHoldingStreamInfoResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return protobuf_1.proto3.util.equals(AdminStreamServiceGetHoldingStreamInfoResponse, a, b);
    }
}
exports.AdminStreamServiceGetHoldingStreamInfoResponse = AdminStreamServiceGetHoldingStreamInfoResponse;
AdminStreamServiceGetHoldingStreamInfoResponse.runtime = protobuf_1.proto3;
AdminStreamServiceGetHoldingStreamInfoResponse.typeName = "spwn.stream.v1.AdminStreamServiceGetHoldingStreamInfoResponse";
AdminStreamServiceGetHoldingStreamInfoResponse.fields = protobuf_1.proto3.util.newFieldList(() => [
    { no: 1, name: "channels", kind: "message", T: admin_common_pb_1.HoldingChannel, repeated: true },
]);
/**
 * @generated from message spwn.stream.v1.AdminStreamServiceGetRestrictedStreamingSettingRequest
 */
class AdminStreamServiceGetRestrictedStreamingSettingRequest extends protobuf_1.Message {
    constructor(data) {
        super();
        /**
         * @generated from field: string video_id = 1;
         */
        this.videoId = "";
        protobuf_1.proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new AdminStreamServiceGetRestrictedStreamingSettingRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new AdminStreamServiceGetRestrictedStreamingSettingRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new AdminStreamServiceGetRestrictedStreamingSettingRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return protobuf_1.proto3.util.equals(AdminStreamServiceGetRestrictedStreamingSettingRequest, a, b);
    }
}
exports.AdminStreamServiceGetRestrictedStreamingSettingRequest = AdminStreamServiceGetRestrictedStreamingSettingRequest;
AdminStreamServiceGetRestrictedStreamingSettingRequest.runtime = protobuf_1.proto3;
AdminStreamServiceGetRestrictedStreamingSettingRequest.typeName = "spwn.stream.v1.AdminStreamServiceGetRestrictedStreamingSettingRequest";
AdminStreamServiceGetRestrictedStreamingSettingRequest.fields = protobuf_1.proto3.util.newFieldList(() => [
    { no: 1, name: "video_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
]);
/**
 * @generated from message spwn.stream.v1.AdminStreamServiceGetRestrictedStreamingSettingResponse
 */
class AdminStreamServiceGetRestrictedStreamingSettingResponse extends protobuf_1.Message {
    constructor(data) {
        super();
        /**
         * 限定配信ページURL
         *
         * @generated from field: string page_url = 1;
         */
        this.pageUrl = "";
        /**
         * 限定配信ページの有効期限 milliseconds 想定
         *
         * @generated from field: int64 expired_at = 2;
         */
        this.expiredAt = protobuf_1.protoInt64.zero;
        protobuf_1.proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new AdminStreamServiceGetRestrictedStreamingSettingResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new AdminStreamServiceGetRestrictedStreamingSettingResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new AdminStreamServiceGetRestrictedStreamingSettingResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return protobuf_1.proto3.util.equals(AdminStreamServiceGetRestrictedStreamingSettingResponse, a, b);
    }
}
exports.AdminStreamServiceGetRestrictedStreamingSettingResponse = AdminStreamServiceGetRestrictedStreamingSettingResponse;
AdminStreamServiceGetRestrictedStreamingSettingResponse.runtime = protobuf_1.proto3;
AdminStreamServiceGetRestrictedStreamingSettingResponse.typeName = "spwn.stream.v1.AdminStreamServiceGetRestrictedStreamingSettingResponse";
AdminStreamServiceGetRestrictedStreamingSettingResponse.fields = protobuf_1.proto3.util.newFieldList(() => [
    { no: 1, name: "page_url", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "expired_at", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
]);
/**
 * @generated from message spwn.stream.v1.AdminStreamServiceCreateRestrictedStreamingPageUrlRequest
 */
class AdminStreamServiceCreateRestrictedStreamingPageUrlRequest extends protobuf_1.Message {
    constructor(data) {
        super();
        /**
         * 配信ID
         *
         * @generated from field: string video_id = 1;
         */
        this.videoId = "";
        /**
         * イベントID
         *
         * @generated from field: string event_id = 2;
         */
        this.eventId = "";
        /**
         * 限定配信ページの有効期限
         *
         * @generated from field: int64 expired_at = 3;
         */
        this.expiredAt = protobuf_1.protoInt64.zero;
        protobuf_1.proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new AdminStreamServiceCreateRestrictedStreamingPageUrlRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new AdminStreamServiceCreateRestrictedStreamingPageUrlRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new AdminStreamServiceCreateRestrictedStreamingPageUrlRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return protobuf_1.proto3.util.equals(AdminStreamServiceCreateRestrictedStreamingPageUrlRequest, a, b);
    }
}
exports.AdminStreamServiceCreateRestrictedStreamingPageUrlRequest = AdminStreamServiceCreateRestrictedStreamingPageUrlRequest;
AdminStreamServiceCreateRestrictedStreamingPageUrlRequest.runtime = protobuf_1.proto3;
AdminStreamServiceCreateRestrictedStreamingPageUrlRequest.typeName = "spwn.stream.v1.AdminStreamServiceCreateRestrictedStreamingPageUrlRequest";
AdminStreamServiceCreateRestrictedStreamingPageUrlRequest.fields = protobuf_1.proto3.util.newFieldList(() => [
    { no: 1, name: "video_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "event_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "expired_at", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
]);
/**
 * @generated from message spwn.stream.v1.AdminStreamServiceCreateRestrictedStreamingPageUrlResponse
 */
class AdminStreamServiceCreateRestrictedStreamingPageUrlResponse extends protobuf_1.Message {
    constructor(data) {
        super();
        /**
         * 限定配信ページURL
         *
         * @generated from field: string page_url = 1;
         */
        this.pageUrl = "";
        protobuf_1.proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new AdminStreamServiceCreateRestrictedStreamingPageUrlResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new AdminStreamServiceCreateRestrictedStreamingPageUrlResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new AdminStreamServiceCreateRestrictedStreamingPageUrlResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return protobuf_1.proto3.util.equals(AdminStreamServiceCreateRestrictedStreamingPageUrlResponse, a, b);
    }
}
exports.AdminStreamServiceCreateRestrictedStreamingPageUrlResponse = AdminStreamServiceCreateRestrictedStreamingPageUrlResponse;
AdminStreamServiceCreateRestrictedStreamingPageUrlResponse.runtime = protobuf_1.proto3;
AdminStreamServiceCreateRestrictedStreamingPageUrlResponse.typeName = "spwn.stream.v1.AdminStreamServiceCreateRestrictedStreamingPageUrlResponse";
AdminStreamServiceCreateRestrictedStreamingPageUrlResponse.fields = protobuf_1.proto3.util.newFieldList(() => [
    { no: 1, name: "page_url", kind: "scalar", T: 9 /* ScalarType.STRING */ },
]);
/**
 * @generated from message spwn.stream.v1.AdminStreamServiceUpdateRestrictedStreamingSettingRequest
 */
class AdminStreamServiceUpdateRestrictedStreamingSettingRequest extends protobuf_1.Message {
    constructor(data) {
        super();
        /**
         * 配信ID
         *
         * @generated from field: string video_id = 1;
         */
        this.videoId = "";
        /**
         * 限定配信ページの有効期限
         *
         * @generated from field: int64 expired_at = 2;
         */
        this.expiredAt = protobuf_1.protoInt64.zero;
        protobuf_1.proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new AdminStreamServiceUpdateRestrictedStreamingSettingRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new AdminStreamServiceUpdateRestrictedStreamingSettingRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new AdminStreamServiceUpdateRestrictedStreamingSettingRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return protobuf_1.proto3.util.equals(AdminStreamServiceUpdateRestrictedStreamingSettingRequest, a, b);
    }
}
exports.AdminStreamServiceUpdateRestrictedStreamingSettingRequest = AdminStreamServiceUpdateRestrictedStreamingSettingRequest;
AdminStreamServiceUpdateRestrictedStreamingSettingRequest.runtime = protobuf_1.proto3;
AdminStreamServiceUpdateRestrictedStreamingSettingRequest.typeName = "spwn.stream.v1.AdminStreamServiceUpdateRestrictedStreamingSettingRequest";
AdminStreamServiceUpdateRestrictedStreamingSettingRequest.fields = protobuf_1.proto3.util.newFieldList(() => [
    { no: 1, name: "video_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "expired_at", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
]);
/**
 * @generated from message spwn.stream.v1.AdminStreamServiceUpdateRestrictedStreamingSettingResponse
 */
class AdminStreamServiceUpdateRestrictedStreamingSettingResponse extends protobuf_1.Message {
    constructor(data) {
        super();
        protobuf_1.proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new AdminStreamServiceUpdateRestrictedStreamingSettingResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new AdminStreamServiceUpdateRestrictedStreamingSettingResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new AdminStreamServiceUpdateRestrictedStreamingSettingResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return protobuf_1.proto3.util.equals(AdminStreamServiceUpdateRestrictedStreamingSettingResponse, a, b);
    }
}
exports.AdminStreamServiceUpdateRestrictedStreamingSettingResponse = AdminStreamServiceUpdateRestrictedStreamingSettingResponse;
AdminStreamServiceUpdateRestrictedStreamingSettingResponse.runtime = protobuf_1.proto3;
AdminStreamServiceUpdateRestrictedStreamingSettingResponse.typeName = "spwn.stream.v1.AdminStreamServiceUpdateRestrictedStreamingSettingResponse";
AdminStreamServiceUpdateRestrictedStreamingSettingResponse.fields = protobuf_1.proto3.util.newFieldList(() => []);
/**
 * @generated from message spwn.stream.v1.AdminStreamServiceDeleteRestrictedStreamingSettingRequest
 */
class AdminStreamServiceDeleteRestrictedStreamingSettingRequest extends protobuf_1.Message {
    constructor(data) {
        super();
        /**
         * 配信ID
         *
         * @generated from field: string video_id = 1;
         */
        this.videoId = "";
        protobuf_1.proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new AdminStreamServiceDeleteRestrictedStreamingSettingRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new AdminStreamServiceDeleteRestrictedStreamingSettingRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new AdminStreamServiceDeleteRestrictedStreamingSettingRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return protobuf_1.proto3.util.equals(AdminStreamServiceDeleteRestrictedStreamingSettingRequest, a, b);
    }
}
exports.AdminStreamServiceDeleteRestrictedStreamingSettingRequest = AdminStreamServiceDeleteRestrictedStreamingSettingRequest;
AdminStreamServiceDeleteRestrictedStreamingSettingRequest.runtime = protobuf_1.proto3;
AdminStreamServiceDeleteRestrictedStreamingSettingRequest.typeName = "spwn.stream.v1.AdminStreamServiceDeleteRestrictedStreamingSettingRequest";
AdminStreamServiceDeleteRestrictedStreamingSettingRequest.fields = protobuf_1.proto3.util.newFieldList(() => [
    { no: 1, name: "video_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
]);
/**
 * @generated from message spwn.stream.v1.AdminStreamServiceDeleteRestrictedStreamingSettingResponse
 */
class AdminStreamServiceDeleteRestrictedStreamingSettingResponse extends protobuf_1.Message {
    constructor(data) {
        super();
        protobuf_1.proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new AdminStreamServiceDeleteRestrictedStreamingSettingResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new AdminStreamServiceDeleteRestrictedStreamingSettingResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new AdminStreamServiceDeleteRestrictedStreamingSettingResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return protobuf_1.proto3.util.equals(AdminStreamServiceDeleteRestrictedStreamingSettingResponse, a, b);
    }
}
exports.AdminStreamServiceDeleteRestrictedStreamingSettingResponse = AdminStreamServiceDeleteRestrictedStreamingSettingResponse;
AdminStreamServiceDeleteRestrictedStreamingSettingResponse.runtime = protobuf_1.proto3;
AdminStreamServiceDeleteRestrictedStreamingSettingResponse.typeName = "spwn.stream.v1.AdminStreamServiceDeleteRestrictedStreamingSettingResponse";
AdminStreamServiceDeleteRestrictedStreamingSettingResponse.fields = protobuf_1.proto3.util.newFieldList(() => []);
/**
 * @generated from message spwn.stream.v1.AdminStreamServiceGetMediaPackageEndpointsRequest
 */
class AdminStreamServiceGetMediaPackageEndpointsRequest extends protobuf_1.Message {
    constructor(data) {
        super();
        /**
         * MediaLiveのチャンネルID
         *
         * @generated from field: string channel_id = 1;
         */
        this.channelId = "";
        protobuf_1.proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new AdminStreamServiceGetMediaPackageEndpointsRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new AdminStreamServiceGetMediaPackageEndpointsRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new AdminStreamServiceGetMediaPackageEndpointsRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return protobuf_1.proto3.util.equals(AdminStreamServiceGetMediaPackageEndpointsRequest, a, b);
    }
}
exports.AdminStreamServiceGetMediaPackageEndpointsRequest = AdminStreamServiceGetMediaPackageEndpointsRequest;
AdminStreamServiceGetMediaPackageEndpointsRequest.runtime = protobuf_1.proto3;
AdminStreamServiceGetMediaPackageEndpointsRequest.typeName = "spwn.stream.v1.AdminStreamServiceGetMediaPackageEndpointsRequest";
AdminStreamServiceGetMediaPackageEndpointsRequest.fields = protobuf_1.proto3.util.newFieldList(() => [
    { no: 1, name: "channel_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
]);
/**
 * @generated from message spwn.stream.v1.AdminStreamServiceGetMediaPackageEndpointsResponse
 */
class AdminStreamServiceGetMediaPackageEndpointsResponse extends protobuf_1.Message {
    constructor(data) {
        super();
        /**
         * @generated from field: repeated spwn.stream.v1.Endpoint endpoints = 1;
         */
        this.endpoints = [];
        protobuf_1.proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new AdminStreamServiceGetMediaPackageEndpointsResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new AdminStreamServiceGetMediaPackageEndpointsResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new AdminStreamServiceGetMediaPackageEndpointsResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return protobuf_1.proto3.util.equals(AdminStreamServiceGetMediaPackageEndpointsResponse, a, b);
    }
}
exports.AdminStreamServiceGetMediaPackageEndpointsResponse = AdminStreamServiceGetMediaPackageEndpointsResponse;
AdminStreamServiceGetMediaPackageEndpointsResponse.runtime = protobuf_1.proto3;
AdminStreamServiceGetMediaPackageEndpointsResponse.typeName = "spwn.stream.v1.AdminStreamServiceGetMediaPackageEndpointsResponse";
AdminStreamServiceGetMediaPackageEndpointsResponse.fields = protobuf_1.proto3.util.newFieldList(() => [
    { no: 1, name: "endpoints", kind: "message", T: admin_common_pb_1.Endpoint, repeated: true },
]);
/**
 * @generated from message spwn.stream.v1.AdminStreamServiceGetMediaLiveChannelsRequest
 */
class AdminStreamServiceGetMediaLiveChannelsRequest extends protobuf_1.Message {
    constructor(data) {
        super();
        protobuf_1.proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new AdminStreamServiceGetMediaLiveChannelsRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new AdminStreamServiceGetMediaLiveChannelsRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new AdminStreamServiceGetMediaLiveChannelsRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return protobuf_1.proto3.util.equals(AdminStreamServiceGetMediaLiveChannelsRequest, a, b);
    }
}
exports.AdminStreamServiceGetMediaLiveChannelsRequest = AdminStreamServiceGetMediaLiveChannelsRequest;
AdminStreamServiceGetMediaLiveChannelsRequest.runtime = protobuf_1.proto3;
AdminStreamServiceGetMediaLiveChannelsRequest.typeName = "spwn.stream.v1.AdminStreamServiceGetMediaLiveChannelsRequest";
AdminStreamServiceGetMediaLiveChannelsRequest.fields = protobuf_1.proto3.util.newFieldList(() => []);
/**
 * @generated from message spwn.stream.v1.AdminStreamServiceGetMediaLiveChannelsResponse
 */
class AdminStreamServiceGetMediaLiveChannelsResponse extends protobuf_1.Message {
    constructor(data) {
        super();
        /**
         * @generated from field: repeated spwn.stream.v1.MediaLiveChannel channels = 1;
         */
        this.channels = [];
        protobuf_1.proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new AdminStreamServiceGetMediaLiveChannelsResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new AdminStreamServiceGetMediaLiveChannelsResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new AdminStreamServiceGetMediaLiveChannelsResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return protobuf_1.proto3.util.equals(AdminStreamServiceGetMediaLiveChannelsResponse, a, b);
    }
}
exports.AdminStreamServiceGetMediaLiveChannelsResponse = AdminStreamServiceGetMediaLiveChannelsResponse;
AdminStreamServiceGetMediaLiveChannelsResponse.runtime = protobuf_1.proto3;
AdminStreamServiceGetMediaLiveChannelsResponse.typeName = "spwn.stream.v1.AdminStreamServiceGetMediaLiveChannelsResponse";
AdminStreamServiceGetMediaLiveChannelsResponse.fields = protobuf_1.proto3.util.newFieldList(() => [
    { no: 1, name: "channels", kind: "message", T: admin_common_pb_1.MediaLiveChannel, repeated: true },
]);
/**
 * @generated from message spwn.stream.v1.AdminStreamServiceGetPremierStreamingScheduleRequest
 */
class AdminStreamServiceGetPremierStreamingScheduleRequest extends protobuf_1.Message {
    constructor(data) {
        super();
        /**
         * MediaLiveのチャンネルID
         *
         * @generated from field: string channel_id = 1;
         */
        this.channelId = "";
        protobuf_1.proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new AdminStreamServiceGetPremierStreamingScheduleRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new AdminStreamServiceGetPremierStreamingScheduleRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new AdminStreamServiceGetPremierStreamingScheduleRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return protobuf_1.proto3.util.equals(AdminStreamServiceGetPremierStreamingScheduleRequest, a, b);
    }
}
exports.AdminStreamServiceGetPremierStreamingScheduleRequest = AdminStreamServiceGetPremierStreamingScheduleRequest;
AdminStreamServiceGetPremierStreamingScheduleRequest.runtime = protobuf_1.proto3;
AdminStreamServiceGetPremierStreamingScheduleRequest.typeName = "spwn.stream.v1.AdminStreamServiceGetPremierStreamingScheduleRequest";
AdminStreamServiceGetPremierStreamingScheduleRequest.fields = protobuf_1.proto3.util.newFieldList(() => [
    { no: 1, name: "channel_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
]);
/**
 * @generated from message spwn.stream.v1.AdminStreamServiceGetPremierStreamingScheduleResponse
 */
class AdminStreamServiceGetPremierStreamingScheduleResponse extends protobuf_1.Message {
    constructor(data) {
        super();
        /**
         * スケジュール設定
         *
         * @generated from field: repeated spwn.stream.v1.AdminStreamServiceGetPremierStreamingScheduleResponse.Schedule schedules = 1;
         */
        this.schedules = [];
        protobuf_1.proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new AdminStreamServiceGetPremierStreamingScheduleResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new AdminStreamServiceGetPremierStreamingScheduleResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new AdminStreamServiceGetPremierStreamingScheduleResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return protobuf_1.proto3.util.equals(AdminStreamServiceGetPremierStreamingScheduleResponse, a, b);
    }
}
exports.AdminStreamServiceGetPremierStreamingScheduleResponse = AdminStreamServiceGetPremierStreamingScheduleResponse;
AdminStreamServiceGetPremierStreamingScheduleResponse.runtime = protobuf_1.proto3;
AdminStreamServiceGetPremierStreamingScheduleResponse.typeName = "spwn.stream.v1.AdminStreamServiceGetPremierStreamingScheduleResponse";
AdminStreamServiceGetPremierStreamingScheduleResponse.fields = protobuf_1.proto3.util.newFieldList(() => [
    { no: 1, name: "schedules", kind: "message", T: AdminStreamServiceGetPremierStreamingScheduleResponse_Schedule, repeated: true },
]);
/**
 * @generated from message spwn.stream.v1.AdminStreamServiceGetPremierStreamingScheduleResponse.Schedule
 */
class AdminStreamServiceGetPremierStreamingScheduleResponse_Schedule extends protobuf_1.Message {
    constructor(data) {
        super();
        /**
         * 蓋絵の開始時刻
         *
         * @generated from field: int32 start_cover_begin_time = 1;
         */
        this.startCoverBeginTime = 0;
        /**
         * 本編の開始時刻
         *
         * @generated from field: int32 begin_time = 2;
         */
        this.beginTime = 0;
        protobuf_1.proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new AdminStreamServiceGetPremierStreamingScheduleResponse_Schedule().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new AdminStreamServiceGetPremierStreamingScheduleResponse_Schedule().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new AdminStreamServiceGetPremierStreamingScheduleResponse_Schedule().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return protobuf_1.proto3.util.equals(AdminStreamServiceGetPremierStreamingScheduleResponse_Schedule, a, b);
    }
}
exports.AdminStreamServiceGetPremierStreamingScheduleResponse_Schedule = AdminStreamServiceGetPremierStreamingScheduleResponse_Schedule;
AdminStreamServiceGetPremierStreamingScheduleResponse_Schedule.runtime = protobuf_1.proto3;
AdminStreamServiceGetPremierStreamingScheduleResponse_Schedule.typeName = "spwn.stream.v1.AdminStreamServiceGetPremierStreamingScheduleResponse.Schedule";
AdminStreamServiceGetPremierStreamingScheduleResponse_Schedule.fields = protobuf_1.proto3.util.newFieldList(() => [
    { no: 1, name: "start_cover_begin_time", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 2, name: "begin_time", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
]);
//# sourceMappingURL=admin_service_pb.js.map